module.exports = __webpack_public_path__ + "img/1521051021.df5b52f6.jpg";